var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_CustomsDeclarationInformationOujian"),
        width: "800px",
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "from-lob": _vm.cloudFile.fromLob,
          "file-size": _vm.cloudFile.fileSize,
          "upload-files": _vm.cloudFile.uploadFiles
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.updateSop
        }
      }),
      _c(
        "el-form",
        { attrs: { "label-width": "100px", "label-position": "left" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SequenceNumber") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        model: {
                          value: _vm.oneFormData.level,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "level", $$v)
                          },
                          expression: "oneFormData.level"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        label: _vm.$t("SeaExport.StatusOfCustomsDeclaration")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.oneFormData.declareCustomsState,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.oneFormData,
                                "declareCustomsState",
                                $$v
                              )
                            },
                            expression: "oneFormData.declareCustomsState"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.PleaseSelect"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.Recorded"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.ListPulled"),
                              value: 2
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.AtReception"),
                              value: 3
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsDeclared"),
                              value: 4
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.Undeclared"),
                              value: 5
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsExamination"),
                              value: 6
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.InspectionExamination"),
                              value: 7
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.ExamedWithoutReleasing"),
                              value: 8
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.AmendDeclaration"),
                              value: 9
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.NotifyToDeclare"),
                              value: 10
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsHasCheck"),
                              value: 11
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsExamed"),
                              value: 12
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsOneRelease"),
                              value: 13
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.CustomsRelease2"),
                              value: 14
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.hasBeanSend"),
                              value: 15
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.notSend"),
                              value: 16
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.sendFailed"),
                              value: 17
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.SelfDeclaration"),
                              value: 18
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TenBitCode") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          filterable: "",
                          "default-value": _vm.oneFormData.tenDigitCode,
                          cache: false,
                          "allow-create": true,
                          "tag-name": "tenDigitCode",
                          "tag-value": "tenDigitCode",
                          "options-width": "260px;",
                          "static-options": _vm.bussinessList
                        },
                        on: { parentCallBack: _vm.tenDigitCodeChangeHandler }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("SeaExport.OperatingCompany") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          filterable: "",
                          "default-value": _vm.oneFormData.companyCname,
                          cache: false,
                          "allow-create": true,
                          "tag-name": "companyCname",
                          "tag-value": "companyCname",
                          "options-width": "250px;",
                          "static-options": _vm.bussinessList
                        },
                        on: { parentCallBack: _vm.queryBusinessHandler }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("SeaExport.CustomsNo") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        model: {
                          value: _vm.oneFormData.customsNo,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "customsNo", $$v)
                          },
                          expression: "oneFormData.customsNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.isSe || _vm.isSi
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "260px" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.job.vessel,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "vessel", $$v)
                              },
                              expression: "job.vessel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: _vm.$t("SeaExport.Voyage") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.job.voyageFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "voyageFlight", $$v)
                              },
                              expression: "job.voyageFlight"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isSi
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "MBL No" } },
                        [
                          _vm.job.typeMBL !== 2
                            ? _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.oneFormData.mblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.oneFormData, "mblNo", $$v)
                                  },
                                  expression: "oneFormData.mblNo"
                                }
                              })
                            : _vm._e(),
                          _vm.job.typeMBL === 2
                            ? _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.oneFormData.mblNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oneFormData, "mblNo", $$v)
                                    },
                                    expression: "oneFormData.mblNo"
                                  }
                                },
                                _vm._l(_vm.mbls, function(value) {
                                  return _c("el-option", {
                                    key: value,
                                    attrs: { label: value, value: value }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "HBL No" }
                        },
                        [
                          _vm.job.typeHBL !== 2
                            ? _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.oneFormData.hblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.oneFormData, "hblNo", $$v)
                                  },
                                  expression: "oneFormData.hblNo"
                                }
                              })
                            : _vm._e(),
                          _vm.job.typeHBL === 2
                            ? _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.oneFormData.hblNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oneFormData, "hblNo", $$v)
                                    },
                                    expression: "oneFormData.hblNo"
                                  }
                                },
                                _vm._l(_vm.hbls, function(value) {
                                  return _c("el-option", {
                                    key: value,
                                    attrs: { label: value, value: value }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAi
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "MAMB No" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.txtMawbNo,
                              callback: function($$v) {
                                _vm.txtMawbNo = $$v
                              },
                              expression: "txtMawbNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "HAWB No" }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.oneFormData.hblNo,
                              callback: function($$v) {
                                _vm.$set(_vm.oneFormData, "hblNo", $$v)
                              },
                              expression: "oneFormData.hblNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _vm.isSe
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px"
                              }
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*")
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.SoNo")))
                              ])
                            ]
                          ),
                          _vm.job.booking
                            ? _c(
                                "el-select",
                                {
                                  staticStyle: { width: "260px" },
                                  model: {
                                    value: _vm.oneFormData.soNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.oneFormData, "soNo", $$v)
                                    },
                                    expression: "oneFormData.soNo"
                                  }
                                },
                                _vm._l(_vm.soNoList, function(value) {
                                  return _c("el-option", {
                                    key: value,
                                    attrs: { label: value, value: value }
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                          !_vm.job.booking
                            ? _c("el-input", {
                                staticStyle: { width: "260px" },
                                model: {
                                  value: _vm.oneFormData.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.oneFormData, "soNo", $$v)
                                  },
                                  expression: "oneFormData.soNo"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _vm.isSe
                        ? _c("div", {
                            staticStyle: {
                              display: "inline-block",
                              width: "10px"
                            }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-block",
                            width: "100px"
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.CustomsBroker")))
                          ])
                        ]
                      ),
                      _vm.isSe
                        ? _c("cargo-advance-select", {
                            staticStyle: {
                              display: "inline-block",
                              width: "250px"
                            },
                            attrs: {
                              filterable: "",
                              "method-params": {
                                customsBroker: true,
                                active: true
                              },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value": _vm.oneFormData.customsBroker,
                              "tag-name": "chineseName"
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.oneFormData.customsBroker =
                                  item.value)
                              }
                            }
                          })
                        : _vm._e(),
                      !_vm.isSe
                        ? _c("cargo-advance-select", {
                            staticStyle: {
                              display: "inline-block",
                              width: "260px"
                            },
                            attrs: {
                              filterable: "",
                              "method-params": {
                                customsBroker: true,
                                active: true
                              },
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "default-value": _vm.oneFormData.customsBroker,
                              "tag-name": "chineseName"
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.oneFormData.customsBroker =
                                  item.value)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.isAe
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "AWB NO" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { disabled: true },
                            model: {
                              value: _vm.txtAwbNo,
                              callback: function($$v) {
                                _vm.txtAwbNo = $$v
                              },
                              expression: "txtAwbNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAi
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            label: _vm.$t("SeaExport.GoodsStoragePlace")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.oneFormData.goodsStoragePlace,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneFormData,
                                  "goodsStoragePlace",
                                  $$v
                                )
                              },
                              expression: "oneFormData.goodsStoragePlace"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-block",
                            width: "100px"
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*")
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BusinessType")))
                          ])
                        ]
                      ),
                      _c("cargo-advance-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "260px"
                        },
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$OJ_LOBS,
                          "default-value": _vm.oneFormData.lob
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.oneFormData.lob = item.code)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        label: _vm.$t("SeaExport.DateOfCustomsDeclaration")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          type: "date",
                          clearable: false,
                          editable: false,
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.oneFormData.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.oneFormData, "customsDate", $$v)
                          },
                          expression: "oneFormData.customsDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.isSi && _vm.isLcl
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.DistributionNo") }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.oneFormData.distributionNo,
                              callback: function($$v) {
                                _vm.$set(_vm.oneFormData, "distributionNo", $$v)
                              },
                              expression: "oneFormData.distributionNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            label: _vm.$t("SeaExport.DistributionWarehouse")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.oneFormData.distributionWarehouse,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneFormData,
                                  "distributionWarehouse",
                                  $$v
                                )
                              },
                              expression: "oneFormData.distributionWarehouse"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isSe || _vm.isSi
            ? _c(
                "el-row",
                [
                  _vm.isSe
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "100px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.PreDateOfCustomsDeclaration"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  type: "date",
                                  clearable: false,
                                  editable: false,
                                  format: "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.oneFormData.preCustomsDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.oneFormData,
                                      "preCustomsDate",
                                      $$v
                                    )
                                  },
                                  expression: "oneFormData.preCustomsDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSi || _vm.isAi
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "140px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ExchangeService"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.oneFormData.exchangeService,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.oneFormData,
                                        "exchangeService",
                                        $$v
                                      )
                                    },
                                    expression: "oneFormData.exchangeService"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSi && !_vm.isLcl
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "100px",
                                    "margin-left": "10px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BillOfLading"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                model: {
                                  value: _vm.oneFormData.billOfLading,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.oneFormData,
                                      "billOfLading",
                                      $$v
                                    )
                                  },
                                  expression: "oneFormData.billOfLading"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isAe || _vm.isAi
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px"
                              }
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*")
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.AirportPort")))
                              ])
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "260px" },
                            model: {
                              value: _vm.oneFormData.airportPort,
                              callback: function($$v) {
                                _vm.$set(_vm.oneFormData, "airportPort", $$v)
                              },
                              expression: "oneFormData.airportPort"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isSi || _vm.isAi
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "140px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.SpecialRelationshipOfBuyer")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.oneFormData.specialRelationshipOfBuyer,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneFormData,
                                    "specialRelationshipOfBuyer",
                                    $$v
                                  )
                                },
                                expression:
                                  "oneFormData.specialRelationshipOfBuyer"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "140px",
                                "margin-left": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.IncludeRoyalty")))]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.oneFormData.includeRoyalty,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneFormData,
                                    "includeRoyalty",
                                    $$v
                                  )
                                },
                                expression: "oneFormData.includeRoyalty"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _vm.isAi
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "140px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ExchangeServiceAi"))
                              )
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.oneFormData.exchangeService,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneFormData,
                                    "exchangeService",
                                    $$v
                                  )
                                },
                                expression: "oneFormData.exchangeService"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isSi || _vm.isAi
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "140px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AffectPrice")))]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.oneFormData.affectPrice,
                                callback: function($$v) {
                                  _vm.$set(_vm.oneFormData, "affectPrice", $$v)
                                },
                                expression: "oneFormData.affectPrice"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isSi
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "140px",
                                "margin-left": "10px"
                              }
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*")
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.WoodPacking")))
                              ])
                            ]
                          ),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.oneFormData.woodPacking,
                                callback: function($$v) {
                                  _vm.$set(_vm.oneFormData, "woodPacking", $$v)
                                },
                                expression: "oneFormData.woodPacking"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Yes")))
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.No")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.CustomsInformation")))
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "48px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.toQuery }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.shouCloudUpload }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AddFile")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "danger" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                  ),
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "10px", color: "red" } },
                    [_vm._v(_vm._s(_vm.$t("Message.ReminderOfTheCustomsData")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      staticStyle: { "margin-top": "5px" }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "200px" } },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "180px" },
                            attrs: {
                              "show-side-bar": false,
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData
                            },
                            on: {
                              gridReady: function(params) {
                                return (_vm.gridApi = params.api)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.oneFormData.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.oneFormData, "remarks", $$v)
                              },
                              expression: "oneFormData.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.enterHandler(2)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Send")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.enterHandler(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }